<template>
  <div class="role_container">

    <div class="sel">
         <select-component
            :configData="configData"
            :multiple="multiple"
            :value="value"
            v-bind="$attrs"
            v-on="$listeners"
            @fatherMethod="openShow"
         />
    </div>

    <a-modal
      title="选择角色"
      :dialogStyle="dialogStyle"
      :width="width"
      :visible="visible"
      switchFullscreen
      @ok="handleOk"
      @cancel="handleCancel"
      cancelText="关闭"
    />
  </div>
</template>
<script>
import SelectComponent from '@/components/jeecgbiz/customComponnent/SelectComponent'

export default {
  components: {
    SelectComponent
  },
  props: {
    value: {
      //已选值
      type: Array,
      default: () => []
    },
    multiple: {
      //是否多选
      type: Boolean,
      default: true
    }
  }
  ,

  data() {
    return {
      visible:false,
      dialogStyle: {
        top: "100px",
        height:"500px",
        width:"1900px"

      },
      width:900,
      //表单配置对象
      configData:
        {
          primaryKey:"id",//提交到后台的字段（用做选中比较的依据）
          displayKey:"name",//用做已选表格字段的显示
          queryKey:"name",//查询输入框的字段
          queryLabel:"广告名称",//查询label的显示
          url:"/sys/ad/list",//接口地址

          colunmList:[//左边表格字段配置
            {
              title:"广告名称",
              ellipsis:true,
              width:100,
              align:"center",
              dataIndex: 'name'
            },
            {
              title:"应用名称",
              align:"center",
              dataIndex: 'applicationName',
              width: 100
            },
            {
              title:"文件类型",
              width: 80,
              align:"center",
              dataIndex: 'fileTypeName'
            },
            {
              title: '操作',
              align: 'center',
              dataIndex: 'action',
              customRender: (text, record, index) => {
                const openInfo =()=>{

                  this.openShow();  // 调用 method 里面的方法
                }
                let content = (<a-button  onClick={ openInfo}></a-button>);
                const obj = {
                  children: content,
                  attrs: { colSpan: 1 },
                };
                return obj;
              }
            }
          ]


        }

    };
  },created() {
   // console.log("$attrs:",this.$attrs)

   //this.$emit('input',  ['11']);
  },
  methods:{
      openShow(){
        this.visible=true;
      },
    handleOk () {
    }, handleCancel() {
      //alert('handleCancel');
      this.$emit('update:visible', false)
      this.visible=false;
      //console.log("fist",this.firstSelectedKeys,this.firstDataSourceSelected)
    }
  }
};
</script>